import { Link } from "react-router-dom";
import { ArrowRight, Wind, Heart, Moon, Sparkles, Hand, Leaf } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { IMG } from "@/lib/site";
import { useT } from "@/lib/i18n";

const HomeAboutMethod = () => {
  const t = useT();
  const tools = [
    { icon: Wind, label: t("home.tool.breath") },
    { icon: Leaf, label: t("home.tool.movement") },
    { icon: Hand, label: t("home.tool.restorative") },
    { icon: Sparkles, label: t("home.tool.mindfulness") },
    { icon: Heart, label: t("home.tool.regulation") },
    { icon: Moon, label: t("home.tool.rest") },
  ];

  return (
    <section className="py-24 md:py-32" data-testid="about-method">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div className="aspect-[5/6] rounded-tl-[4rem] rounded-br-[4rem] overflow-hidden">
                <img src={IMG.casualSmile} alt="Marta Montardit · creadora del Método TAO" className="w-full h-full object-cover" loading="lazy" decoding="async" />
              </div>
              <div className="absolute -top-8 -right-4 md:-right-12 w-40 md:w-56 aspect-square rounded-full overflow-hidden border-8 border-ivory shadow-xl">
                <img src={IMG.chairYoga} alt="Sesión de yoga con sillas" className="w-full h-full object-cover" loading="lazy" decoding="async" />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-6 order-1 lg:order-2">
            <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-6">{t("home.about.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] text-charcoal">
              {t("home.about.title1")} <span className="italic text-terracotta">{t("home.about.title2")}</span>
            </h2>
            <p className="mt-7 text-charcoal/75 text-lg leading-relaxed font-light">
              {t("home.about.p1")}
              <span className="block mt-3 italic text-charcoal">{t("home.about.italic")}</span>
            </p>
            <p className="mt-5 text-charcoal/70 leading-relaxed">
              {t("home.about.p2")}
            </p>
            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {tools.map((tool) => (
                <li key={tool.label} className="flex items-center gap-3 text-charcoal/85">
                  <span className="w-9 h-9 rounded-full bg-sand/70 flex items-center justify-center text-olive">
                    <tool.icon size={16} />
                  </span>
                  <span className="text-[15px]">{tool.label}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/metodo-tao"
              data-testid="about-method-cta"
              className="mt-10 inline-flex items-center gap-2 text-charcoal text-sm font-medium border-b border-terracotta pb-1 hover:text-terracotta transition-colors"
            >
              {t("home.about.cta")} <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HomeAboutMethod;
